module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Promotions/promotion-authorization/promotion-auth-grid/promotion-auth-grid.component.css
// module id = ./src/app/hrms/Promotions/promotion-authorization/promotion-auth-grid/promotion-auth-grid.component.css
// module chunks = main